import React from 'react';
import styles from './Message.module.css';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from './../UIElements/Button/Button';
import DisplayHTMLContent from '../DisplayHTMLContent/DisplayHTMLContent';
import { Margin } from '@mui/icons-material';

function Message(props) {

    const { type, text, labelId, consolidatedReport = false, data = {}, onAccept, onReject, onFeedback, allowHTML, customTextClass, hideConfirmationButtons = false, iconToRender = '', customNoMsg, childComponentToRender = '' } = props;
    const confirmationMessageStyle = (type === "confirm" || type === "continue") ? styles.Confirmation : null;
    const labelMessage = props.intl.formatMessage({ id: 'alert.message.' + labelId });

    const formattedContent = text => {
        if (allowHTML) {
            return (<DisplayHTMLContent content={text} />);
        }
        else {
            return (<span> {text} </span>);
        }
    }

    const onAcceptHandler = () => {
        if (onAccept) {
            onAccept(data);
        }
    }

    const onRejectHandler = () => {
        if (onReject) {
            onReject(data);
        }
    }

    const onFeedbackHandler = () => {
        if (onFeedback) {
            onFeedback(data);
        }
    }

    const getIconToRender = (iconToRender) => {
        let iconInstance, iconAltText = null;
        if (iconToRender === "ACCEPT_ICON") {
            iconInstance = require(`./assets/acceptIcon.svg`).default;
            iconAltText = "Accepted";
        }
        else if (iconToRender === "REJECT_ICON") {
            iconInstance = require(`./assets/rejectIcon.svg`).default;
            iconAltText = "Rejected";
        }
        else if (iconToRender === "HOURGLASS_ICON") {
            iconInstance = require(`./assets/croppedHourGlassIcon.PNG`);
            iconAltText = "Processing";
        }
        else if (iconToRender === "REJECT_RED_ICON") {
            iconInstance = require(`./assets/rejectRedIcon.svg`).default;
            iconAltText = "Rejected";
        }
        return { iconInstance, iconAltText };
    }

    const { iconInstance, iconAltText } = getIconToRender(iconToRender);

    return (
        <>
            <div className={[styles.Message, confirmationMessageStyle, customTextClass].join(" ")}>
                {
                    text ? (
                        <div className={styles.Text}>
                            {formattedContent(text)}
                        </div>
                    ) : null
                }
                {
                    (labelId && !text) ? (
                        <div className={styles.Label}>
                            {formattedContent(labelMessage)}
                        </div>
                    ) : null
                }
                {
                    type === "confirm" && !hideConfirmationButtons && (
                        <div className={styles.Controls}>
                            <div className={styles.Control}>
                                <Button clickHandler={onAcceptHandler}>
                                    <FormattedMessage id="form.radio.yes" />
                                </Button>
                            </div>
                            <div className={styles.Control}>
                                <Button clickHandler={onRejectHandler}>
                                    {customNoMsg ? customNoMsg : <FormattedMessage id="form.radio.no" />}
                                </Button>
                            </div>
                        </div>
                    )
                }
                {
                    type === "feedback" && (
                        <div className={styles.Controls}>
                            <div className={styles.Control}>
                                <Button style={{ 
                            textTransform: 'none',
                            margin: '20px'
                        }}clickHandler={onFeedbackHandler}>
                                    <FormattedMessage id="qualitrics.feedback-button" />
                                </Button>
                            </div>
                        </div>
                    )
                }
                {
                    type === "continue" && !hideConfirmationButtons && (
                        <div className={styles.Controls}>
                            <div className={styles.Control}>
                                <Button clickHandler={onAcceptHandler}>
                                    <FormattedMessage id="checkout.button.continue" />
                                </Button>
                            </div>
                            <div className={styles.Control}>
                                <Button clickHandler={onRejectHandler}>
                                    {customNoMsg ? customNoMsg : <FormattedMessage id="checkout.button.cancel" />}
                                </Button>
                            </div>
                        </div>
                    )
                }

                {!consolidatedReport && iconInstance && iconAltText && (<img src={iconInstance} alt={iconAltText} />)}
                {!consolidatedReport && childComponentToRender}
            </div>

            {consolidatedReport && iconInstance && iconAltText ? (
                <div className={styles.Message}>
                    <img src={iconInstance} alt={iconAltText} />
                </div>
            ) : null
            }

            {consolidatedReport && childComponentToRender ? (
                <div className={styles.Message}>
                    {childComponentToRender}
                </div>
            ) : null
            }
        </>
    )
}

Message.propTypes = {
    type: PropTypes.string
}

export default (injectIntl(Message));
